import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa6";

const ProductDesc = ({ ProductDescriptions }) => {
  const [showBenefit, setShowBenefit] = useState(false);
  const [showProductUse, setShowProductUse] = useState(false);

  return (
    <section className="text-lg leading-relaxed flex flex-col mx-auto sm:gap-5 gap-3">
      {/********* Product Description Section  *******/}

      <div className="">
        <div className="font-semibold md:text-2xl text-xl flex items-center justify-between py-3">
          <h2>Product Description</h2>
        </div>
        <div className="text-mediumGray md:text-base text-sm">
          {ProductDescriptions?.product_description &&
            ProductDescriptions?.product_description?.map((desc) => {
              const { id, description } = desc;
              return (
                <p key={Number(id)} className="md:py-2 py-1">
                  {description}
                </p>
              );
            })}
        </div>
      </div>

      {/*********   Product Benefits Section    *******/}

      {ProductDescriptions?.benefits?.length >= 1 && (
        <div className="">
          <div
            className={`font-semibold md:text-2xl text-xl flex items-center justify-between sm:p-3 p-2 rounded-xl border border-lightGray`}
            onClick={() => setShowBenefit(!showBenefit)}
          >
            <h2>Benefits</h2>
            <p className="text-mediumGray">
              {showBenefit ? <FaChevronUp /> : <FaChevronDown />}
            </p>
          </div>
          <div
            className={`overflow-hidden transition-all duration-300 ease-in-out ${
              showBenefit ? "max-h-[500px]" : "max-h-0"
            }`}
          >
            <ul className="text-mediumGray md:pl-8 pl-4 md:text-base text-sm">
              {ProductDescriptions?.benefits.map((desc) => {
                const { id, description } = desc;
                return (
                  showBenefit && (
                    <li key={Number(id)} className="md:py-2 py-1 list-disc">
                      {description}
                    </li>
                  )
                );
              })}
            </ul>
          </div>
        </div>
      )}

      {/*********   Product uses Section    *******/}

      {ProductDescriptions?.how_To_Use?.length >= 1 && (
        <div className="">
          <div
            className={`font-semibold md:text-2xl text-xl flex items-center justify-between sm:p-3 p-2 border border-lightGray
               rounded-xl `}
            onClick={() => setShowProductUse(!showProductUse)}
          >
            <h2>Product Use</h2>
            <p className="text-mediumGray">
              {showProductUse ? <FaChevronUp /> : <FaChevronDown />}
            </p>
          </div>
          <div
            className={`overflow-hidden transition-all duration-300 ease-in-out ${
              showProductUse ? "max-h-[500px]" : "max-h-0"
            }`}
          >
            <ul className="text-mediumGray md:pl-8 pl-4">
              {ProductDescriptions?.how_To_Use.map((desc) => {
                const { id, description } = desc;
                return (
                  showProductUse && (
                    <li
                      key={Number(id)}
                      className="md:py-2 py-1 list-disc md:text-base text-sm"
                    >
                      {description}
                    </li>
                  )
                );
              })}
            </ul>
          </div>
        </div>
      )}
    </section>
  );
};

export default ProductDesc;
